import fetch from 'isomorphic-fetch';
import * as constants from './constants';

export function requestLocations() {
  return {
    type: constants.REQUEST_LOCATIONS
  }
}

export function receiveLocations(json) {
  return {
    type: constants.RECEIVE_LOCATIONS,
    locations: json
  }
}

export function requestPartners() {
  return {
    type: constants.REQUEST_PARTNERS
  }
}

export function receivePartners(json) {
  return {
    type: constants.RECEIVE_PARTNERS,
    partnerList: json
  }
}

export function requestFeaturedLocations() {
  return {
    type: constants.REQUEST_FEATURED_LOCATIONS
  }
}

export function receiveFeaturedLocations(json) {
  return {
    type: constants.RECEIVE_FEATURED_LOCATIONS,
    featured: json
  }
}

export function fetchPartners() {
  return dispatch => {
    dispatch(requestPartners())
    return fetch('data/partners.json')
      .then(response => response.json())
      .then(json => dispatch(receivePartners(json)))
  }
}

export function fetchLocations() {
  return dispatch => {
    dispatch(requestLocations())
    return fetch('data/locations.json')
      .then(response => response.json())
      .then(json => dispatch(receiveLocations(json)))
  }
}

export function fetchFeaturedLocations() {
  return dispatch => {
    dispatch(requestFeaturedLocations())
    return fetch('data/featured-locations.json')
      .then(response => response.json())
      .then(json => dispatch(receiveFeaturedLocations(json)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/actions.js